import * as React from 'react'
import { cn } from '../../lib/utils'

export const PageFrame = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'mx-auto box-border flex w-full min-w-0 max-w-[var(--page-content-max)] flex-col gap-[var(--mobile-section-gap)] px-[var(--mobile-page-padding-x)] pb-[var(--page-padding-bottom)] pt-[var(--page-padding-top)] sm:gap-[var(--page-section-gap)] sm:px-[var(--page-padding-x)]',
      className,
    )}
    {...props}
  />
))
PageFrame.displayName = 'PageFrame'
